import { PAGE_VIEW } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import NoOptionField from './NoOptionField';
import once from 'transmute/once';
export default once(() => NoOptionField({
  filterFamily: PAGE_VIEW
}));